import { RangeOption } from "../types"
import {
  GOALS_SCORE_RANGE_BY_SUBJECT_SUBPAGE,
  GOALS_SCORE_RANGE_BY_TEST_SUBPAGE,
  GOALS_SUMMARY_BY_PROGRAM_SUBPAGE,
  GOALS_SUMMARY_BY_SUBJECT_SUBPAGE,
  SCORE_GOALS_BY_PROGRAM_VIEW_SUBPAGE,
  SCORE_GOALS_BY_SUBJECT_VIEW_SUBPAGE
} from "./tables/performance"

export const FIRST_DATE = "2020-01-01"

export const DATE_FORMAT = "yyyy-MM-dd"

export const DETAILS_DATE_FORMAT = "M/dd/yyyy"

export const DATE_OPTIONS: RangeOption[] = [
  {
    value: "this school year",
    label: "Current School Year",
    chipLabel: "Current Year"
  },
  { value: "last 7 days", label: "Last 7 Days" },
  { value: "last 30 days", label: "Last 30 Days" },
  { value: "last school year", label: "Last School Year" }
  // { value: "custom", label: "Custom Dates" }
]

export const DATE_ALIAS = {
  "entire school year": "this school year"
}

export const ALERT_FILTER_DATE_VALUE = {
  "this school year": "Current School Year",
  "last 7 days": "Last 7 Days",
  "last 30 days": "Last 30 Days",
  "last school year": "Last School Year",
  custom: "Custom Range"
}

export const UNTIMED_ENTITIES = [
  // Organization
  "states",
  "districts",
  "admins",
  "schools",
  "teachers",
  "classes",
  "students",
  // Content
  "content-library",
  "content-library/element",
  "content-library/study-hall",
  "content-library/practice-test",
  "content-library/mastery-lesson",
  "content-library/mastery-curriculum",
  // Performance
  "answers"
]

export const PART_TIMED_ENTITIES = ["districts", "schools"]

export const TIME_DIMENSIONS = {
  districts: "org_view_districts.createdAt",
  admins: "org_view_admins.createdAt",
  schools: "org_view_schools.createdAt",
  teachers: "org_view_teachers.createdAt",
  classes: "org_view_classes.createdAt",
  students: "org_view_students.createdAt",
  states: "org_view_states.createdAt",
  "activity-log": "usage_activity_logs.dateTime",
  "details-usage": "usage_activity_logs.dateTime",
  "students-usage": "usage_students.createdAt",
  "teachers-usage": "usage_teachers.createdAt",
  questions: "questions_view.answersCompletedAt",
  studentQuestions: "questions_view.answersCompletedAt",
  scores: "scores_view.completedAt",
  "subtests-scores": "scores_subtests_view.completedAt",
  [GOALS_SUMMARY_BY_PROGRAM_SUBPAGE]: "goals_summary_by_program.dateTime",
  [GOALS_SUMMARY_BY_SUBJECT_SUBPAGE]: "goals_summary_by_subject.dateTime",
  [SCORE_GOALS_BY_PROGRAM_VIEW_SUBPAGE]:
    "score_goals_by_program_view.completedAt",
  [SCORE_GOALS_BY_SUBJECT_VIEW_SUBPAGE]:
    "score_goals_by_subject_view.completedAt",
  [GOALS_SCORE_RANGE_BY_TEST_SUBPAGE]:
    "test_view_students_by_test.testCompletedAt",
  [GOALS_SCORE_RANGE_BY_SUBJECT_SUBPAGE]:
    "test_view_students_by_subject.testCompletedAt"
}

export const CONTENT_LIBRARY_TIME_DIMENTIONS = {
  "content-library/element_id": "content_view_br_lessons.createdAt",
  "content-library/study-hall_id": "content_view_sh_lessons.createdAt",
  "content-library/practice-test_id": "content_view_tests.completedAt",
  "content-library/mastery-lesson_id": "content_view_ml_lessons.createdAt",
  "content-library/mastery-curriculum_id": "content_view_mc_lessons.createdAt"
}
